var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "row my-4" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _vm.reviews && _vm.reviews.length > 0
            ? [
                _vm._l(_vm.reviews, function(review) {
                  return _c(
                    "div",
                    { key: review.id, staticClass: "customer-review-card" },
                    [
                      _c("div", [
                        _c("div", { staticClass: "customer-photo-section" }, [
                          _c("img", {
                            directives: [
                              {
                                name: "lazy",
                                rawName: "v-lazy",
                                value: review.customer_picture,
                                expression: "review.customer_picture"
                              }
                            ],
                            staticClass:
                              "rounded-circle img-fluid img-reviewer p-0",
                            attrs: { alt: "customer picture" }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "customer-review-body" }, [
                          _c("div", { staticClass: "reply-name" }, [
                            _vm._v(
                              _vm._s(_vm._f("firstName")(review.customer_name))
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$options.filters.ratingStar(review.rating)
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-secondary" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("prettyOnlyDate")(review.create_date)
                                )
                              )
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" }),
                      _vm._v(" "),
                      review.comment
                        ? _c("div", { staticClass: "text-long mt-3" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(review.comment) +
                                "\n          "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-right mt-3" }, [
                        _c("div", [
                          _c(
                            "div",
                            { staticClass: "professional-picture-box" },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm._f("firstName")(
                                      review.professional_name
                                    )
                                  ) +
                                  "\n                "
                              ),
                              _c("img", {
                                directives: [
                                  {
                                    name: "lazy",
                                    rawName: "v-lazy",
                                    value: review.professional_picture,
                                    expression: "review.professional_picture"
                                  }
                                ],
                                staticClass:
                                  "rounded-circle img-fluid p-0 ml-2",
                                attrs: {
                                  alt: "professional picture c",
                                  width: "48"
                                }
                              }),
                              _vm._v(" "),
                              review.is_excellent === 1
                                ? _c("img", {
                                    directives: [
                                      {
                                        name: "b-popover",
                                        rawName: "v-b-popover.hover.top",
                                        value: _vm.$i18n.t(
                                          "message.professional.excellent_provider_detail",
                                          {
                                            name: _vm.firstName(
                                              review.professional_name
                                            )
                                          }
                                        ),
                                        expression:
                                          "$i18n.t('message.professional.excellent_provider_detail', {name: firstName(review.professional_name)})",
                                        modifiers: { hover: true, top: true }
                                      }
                                    ],
                                    staticClass: "badge-excellent",
                                    attrs: {
                                      src: "/static/img/ic_badge_excellent.png",
                                      width: "22",
                                      title: _vm.$i18n.t(
                                        "message.professional.excellent_provider_title"
                                      )
                                    }
                                  })
                                : _vm._e()
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("hr")
                    ]
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "text-center" }, [
                  _vm.isMore
                    ? _c(
                        "a",
                        {
                          staticClass: "btn btn-outline-info",
                          attrs: { href: "", disabled: _vm.isFetching },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.fetchReviews.apply(null, arguments)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t(_vm.isLoadMore)) +
                              "\n          "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ]
            : _vm._e()
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b141ac3e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b141ac3e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/professional/ProfessionalRecentReviews.vue
// module id = 2009
// module chunks = 0